<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MnTkw6/tc-custom/9781439108338.jpg?1730523537474" alt="This image is the cover for the book Primer on Decision Making"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Primer on Decision Making
      </h1>
      <p class="bookDescription body article font2">
        <p>Building on lecture notes from his acclaimed course at Stanford University, James March provides a brilliant introduction to decision making, a central human activity fundamental to individual, group, organizational, and societal life. March draws on research from all the disciplines of social and behavioral science to show decision making in its broadest context. By emphasizing how decisions are actually made -- as opposed to how they should be made -- he enables those involved in the process to understand it both as observers and as participants.<br/><br/>March sheds new light on the decision-making process by delineating four deep issues that persistently divide students of decision making: Are decisions based on rational choices involving preferences and expected consequences, or on rules that are appropriate to the identity of the decision maker and the situation? Is decision making a consistent, clear process or one characterized by ambiguity and inconsistency? Is decision making significant primarily for its outcomes, or for the individual and social meanings it creates and sustains? And finally, are the outcomes of decision processes attributable solely to the actions of individuals, or to the combined influence of interacting individuals, organizations, and societies? March's observations on how intelligence is -- or is not -- achieved through decision making, and possibilities for enhancing decision intelligence, are also provided.<br/><br/>March explains key concepts of vital importance to students of decision making and decision makers, such as limited rationality, history-dependent rules, and ambiguity, and weaves these ideas into a full depiction of decision making.<br/><br/>He includes a discussion of the modern aspects of several classic issues underlying these concepts, such as the relation between reason and ignorance, intentionality and fate, and meaning and interpretation.<br/><br/>This valuable textbook by one of the seminal figures in the history of organizational decision making will be required reading for a new generation of scholars, managers, and other decision makers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James G. March
      </h2>
      
      <p class="authorDescription body article">James G. March is a co-author of <I>Rediscovering Institutions</I>, a Free Press book.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon & Schuster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eedd8cec